import {useRouter} from '@typed-router';
import {defineNuxtRouteMiddleware} from '#app';
import {useAuth, useImmersionMode} from '#imports';

export default defineNuxtRouteMiddleware(async () => {
    const router = useRouter();
    const {isThisIdentityInImmersionMode} = useAuth();
    const {getImmersionOwner, setImmersionFrame} = useImmersionMode();

    const immersionIdentityId = router.currentRoute.value.query.immersion as string;

    if (immersionIdentityId && isThisIdentityInImmersionMode(immersionIdentityId)) {
        try {
            const immersionOwner = await getImmersionOwner({id: immersionIdentityId, type: 'IDENTITY_ID'});
            setImmersionFrame(immersionOwner);
        } catch {}
    }
});
